import React, { useState, useContext, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import { FiHelpCircle } from 'react-icons/fi'
import { AiFillCaretUp } from 'react-icons/ai'
import { FaUserCircle, FaAngleDown } from 'react-icons/fa'

import './styles.css'
import StoreContext from '../storage/context';

import naturaIconHeader from '../../assets/logo-natura-white.svg';

const Header = () => {
    const {
        removeToken,
        removePKUser,
        removeRACF,
        pk_user,
        givenName,
        removePKService,
        removeDisplayName,
        removeGivenName
    } = useContext(StoreContext);
    const [hidden, setHidden] = useState('header-hidden');

    const signOut = () => {
        removeToken()
        removePKUser()
        removeRACF()
        removePKService()
        removeDisplayName()
        removeGivenName()
    }

    const wrapperRef = useRef(null);

    useOutsideAlerter(wrapperRef, setHidden);

    return (
        <div className="header-container">
            <div className="header-content">
                <Link to="/">
                    <img className="header-icon" src={naturaIconHeader} />
                </Link>
                <div className="header-container-help">
                    <Link to="/faq">
                        <FiHelpCircle className="header-icon-help" size={25} color="white"/>
                    </Link>
    
                    <div onClick={() => (hidden ==='header-hidden') ? setHidden('header-show') : setHidden('header-hidden')}>
                        <FaUserCircle size={25} color="white" />
                        <FaAngleDown size={20} color="white" />
                    </div>
                    <div ref={wrapperRef} className={hidden}>
                        <AiFillCaretUp className="header-container-up" size={25} color="white" />
                        <div className="header-container-list">
                            <p className="header-welcome" >Olá, {givenName}</p>
                            <hr />
                            <button className="header-btn" onClick={signOut}>Sair</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

/**
 * Hook that alerts clicks outside of the passed ref
 */
 function useOutsideAlerter(ref, setHidden) {
    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setHidden('header-hidden')
            }
        }

        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
}


export default Header;
